import * as R from 'ramda';
import { AppState } from './appState';
import { ActionType } from './actionType';
import { Action } from 'redux';
import { PortalType } from '../../navigation/portalType';


type SetPortalTypeAction = {
  type: ActionType.SetPortalTypeAction;
  portalType: PortalType;
}


/**
 * Generally, you don't want to use this action, but it's useful in a handful of circumstances.
 * Deep-merges the state given here onto the current app state.
 */
export const setPortalTypeAction = (
  portalType: PortalType,
): SetPortalTypeAction => ({
  type:     ActionType.SetPortalTypeAction,
  portalType: portalType,
});


export const setPortalTypeReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.SetPortalTypeAction) {
    return state;
  }

  return R.assoc(
    'portalType',
    (action as SetPortalTypeAction).portalType,
    state,
  );
};
